export const BASE_URL = process.env.REACT_APP_BACKEND_API;
export const POSTS_PER_PAGE = 3;
export const COMMENTS_PER_POST = 3;
export const CLOUDINARY_CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
export const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
